<app-page-grid [title]="'recetas'" [type]="'recipes'"></app-page-grid>